---
fr:
  ppa_pricing:
    charts:
      buy_back_cost_title: Coût d'achat (EUR)
      buy_back_volume_title: Volume d'achat en % de la production annuelle
      portfolio_reference_title: Portefeuille et profil de référence
      profile_risk: Profil de risque [%]
      simulated_revenue_development: Évolution des revenus simulée
    factors:
      cannibalism: Cannibalisation
      cash_flow: Flux de trésorerie
      liquidity: Liquidité
      price: Prix
      profile: Profil
      volume: Production
    hedging_strategy: Stratégie de couverture des prix et des risques
    liquidity: Liquidité
    portfolio_attributes: Attributs du portefeuille
    pricing: Tarification
    pricing_and_risk: Tarification des produits et risques
    risk_factors: Facteurs de risque
    risk_factors_additional: Facteurs de risque supplémentaires
    risk_factors_mitigated: Facteurs de risque atténués
